import { cloneDeep } from 'lodash';
import React, { useEffect, useState } from 'react';
import { BaseOperateView, IFramework } from '@/framework';
import { ILayerProps, LayerType } from '@/version-types';
import MoveImageAction from './hooks/image-move-change-action';
import ImageRotateChangeAction from './hooks/image-rotate-change-action';
import ImageSizeChangeAction from './hooks/image-size-change-action';
import LayerResizeChangeAction from './hooks/layer-resize-change-action';
import LayerScaleChangeAction from './hooks/layer-size-change-action';
import ImageOperate from './image-operate';
import LayerOperate from './layer-operate';

const CropImgWrap: React.FC<{
    scale: number;
    stageWidth: number;
    stageHeight: number;
    framework: IFramework;
    identity: string;
    isAutoCutoutLayer: boolean;
}> = ({ scale, framework, isAutoCutoutLayer }) => {
    const [activeLayer, setActiveLayer] = useState<ILayerProps | null>(
        framework.operate.getActivePickLayer() || framework.operate.getActiveLayer(),
    );

    const layerId = activeLayer?.id;

    // useMoveImage(scale, framework);
    const [originLayer] = useState(cloneDeep(activeLayer));

    useEffect(() => {
        if (!layerId) return;
        const handler = framework.events.onLayerChange(() => {
            setActiveLayer(framework.operate.getActivePickLayer() || framework.operate.getActiveLayer());
        }, layerId);

        return () => {
            framework.events.off(handler);
        };
    }, [layerId]);

    // 防止闪一下
    if (!activeLayer || activeLayer?.layerType !== LayerType.IMAGE_LAYER || !originLayer) {
        return null;
    }

    if (!activeLayer.__isCropImage) {
        return null;
    }

    return (
        <BaseOperateView layer={{ ...activeLayer, id: `${activeLayer.id}-crop-img` }}>
            <ImageOperate layer={activeLayer} scale={scale} />
            <LayerOperate layer={activeLayer} scale={scale} isAutoCutoutLayer={isAutoCutoutLayer} />
            <MoveImageAction stageScale={scale} framework={framework} />
            <ImageSizeChangeAction stageScale={scale} framework={framework} />
            <ImageRotateChangeAction stageScale={scale} framework={framework} />
            <LayerScaleChangeAction stageScale={scale} framework={framework} isAutoCutoutLayer={isAutoCutoutLayer} />
            <LayerResizeChangeAction stageScale={scale} framework={framework} />
        </BaseOperateView>
    );
};

export default CropImgWrap;
